/* ============================================================================
   EL TRANSPORTE — las tres llamadas del protocolo

   Nunca lanza. Devuelve `{ ok, estado, datos, motivo }` y deja que el motor
   decida: un 403 en una entidad no es una caída del servidor, y un 503 sin base
   no es un error del vuelo que se acaba de anotar.

   La empresa y el usuario NO viajan en el cuerpo ni en la URL. Salen de la
   cookie de sesión, en el servidor. Mandarlos desde acá sería ofrecer una forma
   de escribir en otra empresa cambiando un número.
   ========================================================================== */

const RUTA = "/api/sincronizar";

async function pedir(ruta, { metodo = "GET", cuerpo = null, fetchImpl } = {}) {
    const hacer = fetchImpl || (typeof fetch === "function" ? fetch : null);
    if (!hacer) {
        return { ok: false, estado: 0, motivo: "Este navegador no puede hablar con el servidor." };
    }

    try {
        const respuesta = await hacer(ruta, {
            method: metodo,
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: cuerpo === null ? undefined : JSON.stringify(cuerpo),
        });

        let datos = null;
        try { datos = await respuesta.json(); } catch { datos = null; }

        if (respuesta.ok) return { ok: true, estado: respuesta.status, datos };
        return {
            ok: false,
            estado: respuesta.status,
            motivo: datos?.error || "El servidor no pudo completar la sincronización.",
        };
    } catch {
        return {
            ok: false,
            estado: 0,
            motivo: "No se pudo hablar con el servidor. Revisa la conexión.",
        };
    }
}

export function crearTransporte({ fetchImpl = null, base = RUTA } = {}) {
    return {
        estado() {
            return pedir(`${base}/estado`, { fetchImpl });
        },

        traer(entidad, { desde = 0, cursor = null, limite = 0 } = {}) {
            const parametros = new URLSearchParams();
            if (Number(desde) > 0) parametros.set("desde", String(desde));
            if (cursor?.id) {
                parametros.set("cursor_actualizado_en", String(cursor.actualizado_en));
                parametros.set("cursor_id", String(cursor.id));
            }
            if (Number(limite) > 0) parametros.set("limite", String(limite));
            const cola = parametros.toString();
            return pedir(`${base}/${encodeURIComponent(entidad)}${cola ? `?${cola}` : ""}`, { fetchImpl });
        },

        enviar(cambios) {
            return pedir(base, {
                metodo: "POST",
                cuerpo: { cambios },
                fetchImpl,
            });
        },
    };
}
